import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterDMQDDVT({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    vat_tu: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.vat_tu) {
      condition.ma_vt = filter.vat_tu.ma_vt;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterSelectApi
        direction="column"
        label="Hàng hóa"
        placeholder="Chọn hàng hóa"
        selectTitle="Chọn hàng hóa"
        placeholderSearch="Tìm theo mã, tên hàng"
        apiCode="dmvt"
        searchFields={["ma_vt", "ten_vt"]}
        getOptionLabel={(option) => option.ten_vt}
        checkEqual={(value, option) => value?.ma_vt === option?.ma_vt}
        value={filter.vat_tu}
        onChange={(val) => setFilter({ ...filter, vat_tu: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMQDDVT;
